import React, { useState, useEffect } from "react";
import { Dialog, IconButton, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const KitchenGallery = ({
  open = false,
  onClose,
  images = [],
  startIndex = 0,
}) => {
  const [currentIndex, setCurrentIndex] = useState(startIndex || 0);

  useEffect(() => {
    setCurrentIndex(startIndex);
  }, [startIndex]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: "#000",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        },
      }}
    >
      {/* Top Bar */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        py={1.5}
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          width: "100%",
          zIndex: 9999,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          backdropFilter: "blur(10px)",
          minHeight: "60px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            color: "#fff",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            },
            minWidth: "44px",
            minHeight: "44px",
            borderRadius: "50%",
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="body2" color="#fff" fontWeight={500}>
          {`${currentIndex + 1} / ${images.length}`}
        </Typography>

        <Box width={44} />
      </Box>

      {/* Image Viewer */}
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          pt: "60px", // Add padding top to account for the fixed header
        }}
      >
        {/* Left Arrow */}
        <IconButton
          onClick={handlePrev}
          sx={{
            position: "absolute",
            left: 24,
            top: "50%",
            transform: "translateY(-50%)",
            color: "#fff",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.3)" },
            minWidth: "44px",
            minHeight: "44px",
            zIndex: 1000,
          }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>

        <img
          src={images[currentIndex]}
          alt={`Kitchen Image ${currentIndex + 1}`}
          style={{
            maxWidth: "100vw",
            maxHeight: "calc(100vh - 60px)",
            objectFit: "contain",
          }}
        />

        {/* Right Arrow */}
        <IconButton
          onClick={handleNext}
          sx={{
            position: "absolute",
            right: 24,
            top: "50%",
            transform: "translateY(-50%)",
            color: "#fff",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.3)" },
            minWidth: "44px",
            minHeight: "44px",
            zIndex: 1000,
          }}
        >
          <ArrowForwardIosIcon />
        </IconButton>
      </Box>
    </Dialog>
  );
};

export default KitchenGallery;
